<template>
  <div class="ui-h100">
    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {},
    components: {},
    beforeCreate() {
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    beforeUpdate() {
    },
    updated() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
    },
    beforeRouteUpdate(to, from, next) {
      // 在当前路由改变，但是该组件被复用时调用
      // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
      // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
      // 可以访问组件实例 `this`
    },
    beforeRouteLeave(to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
    },
    data() {
      return {};
    },
    mixins: [],
    methods: {},
    computed: {},
    watch: {}
  };
</script>

<style lang="less">
  @import './assets/less/index';
  .fade-enter-active,
  .fade-leave-active {
    transition: all .3s ease;
    opacity: 0;
  }

  .fileList-popover {
    padding: 0px;
    min-width: auto;
    width: 100px;
    /*border: 1px solid #979797;*/
  }

  .fileList-popover .popper__arrow {
    border-bottom-color: #979797;
  }

  /*.fileMenu-popover {*/
    /*padding: 0px;*/
    /*background: red;*/
    /*min-width: auto;*/
    /*width: 60px;*/
  /*}*/

  /*.fileMenu-popover-item {*/
    /*font-size: 12px;*/
    /*width: 60px;*/
    /*height: 24px;*/
    /*line-height: 24px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/pages/admin/App.vue